import { useEffect, useState } from 'react';
import axios from 'axios';
import MainURL from '../../../MainURL';
import type { RecruitApplyType } from '../../../types/application';

/** 공고의 지원 경로 (server routers/resume/applyRelay.js GET /applyrelay/channel) */
export interface ApplyChannel {
  state: 'open' | 'closed' | 'deleted';
  /** 관리자가 확인한 교회 — '인증 교회' 배지 */
  churchVerified: boolean;
  email: string | null;
  phone: string | null;
  contactName: string;
  /** 지원방법 문구에서 읽은 수단 — email · post · visit · phone · homepage · site */
  methods: string[];
  /** 가져온 공고의 지원 방식 — ONSITE(즉시 전달) · RESERVE(교회가 인수할 때 전달) · EXTERNAL(원문으로 지원) */
  applyMode?: 'ONSITE' | 'RESERVE' | 'EXTERNAL';
  /** 미선점 가져온 공고의 원문 링크 */
  sourceUrl?: string | null;
  /** 이력서 파일로 지원 → 사이트에 접수, 교회 이메일로는 첨부 없는 알림 (교회 이메일이 있어야 가능) */
  fileApply: boolean;
  /** 사이트 이력서로 지원 */
  resumeApply: boolean;
  fileRules: { maxFiles: number; maxFileMb: number; maxTotalMb: number; extensions: string[] };
}

export function useApplyChannel(recruitType: RecruitApplyType | null, recruitId: string | null) {
  const [channel, setChannel] = useState<ApplyChannel | null>(null);

  useEffect(() => {
    if (!recruitType || !recruitId) return;
    let alive = true;
    axios.get(`${MainURL}/applyrelay/channel/${recruitType}/${recruitId}`)
      .then(res => { if (alive && res.data.success) setChannel(res.data as ApplyChannel); })
      .catch(() => { if (alive) setChannel(null); });
    return () => { alive = false; };
  }, [recruitType, recruitId]);

  return channel;
}
